import axios from 'axios';
import { authHeader } from '../_helpers';
// import qs from 'qs';
const _appDomain = process.env.VUE_APP_DOMAIN ? process.env.VUE_APP_DOMAIN : '';
const _apiUrl = _appDomain + process.env.VUE_APP_API_URL;

export default {
  create(uri, data) {
    return axios({
      method: 'post',
      url: _apiUrl + uri,
      headers: {
        Authorization: authHeader()
      },
      data: data
    });
  },
  read(uri, { signal } = {}) {
    return axios({
      method: 'get',
      headers: {
        Authorization: authHeader()
      },
      url: _apiUrl + uri,
      signal
    });
  },
  get(uri) {
    return axios({
      url: uri._links.self.href,
      method: 'get',
      headers: {
        Authorization: authHeader()
      }
    });
  },
  update(uri, data, isPut) {
    return axios({
      method: isPut === false || isPut === undefined ? 'patch' : 'put',
      url: _apiUrl + uri,
      headers: {
        Authorization: authHeader()
      },
      data: data
    });
  },
  delete(uri) {
    return axios({
      method: 'delete',
      url: _apiUrl + uri,
      headers: {
        Authorization: authHeader()
      }
    });
  },
  search(uri, data) {
    return axios({
      method: 'post',
      url: _apiUrl + uri,
      headers: {
        Authorization: authHeader()
      },
      data: data
    });
  },
  searchBySeq(uri, params) {
    return axios({
      method: 'get',
      url: _apiUrl + uri,
      headers: {
        Authorization: authHeader()
      },
      params: params
    });
  },

  getResource(uri, params, { signal } = {}) {
    return axios({
      method: 'get',
      url: uri,
      headers: {
        Authorization: authHeader()
      },
      params: params,
      signal
    });
  },

  getApiResource(uri, params, { signal } = {}) {
    return axios({
      method: 'get',
      url: _apiUrl + uri,
      headers: {
        Authorization: authHeader()
      },
      params: params,
      signal
    });
  },
  examineReport: {
    create(uri, data) {
      return axios.post(
        _appDomain + uri,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': authHeader()
          }
        }
      );
    },
    update(uri, data) {
      return axios.put(
        _appDomain + uri,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': authHeader()
          }
        }
      );
    },
    delete(uri) {
      return axios({
        method: 'delete',
        url: _appDomain + uri,
        headers: {
          Authorization: authHeader()
        }
      });
    }
  },
  dashboard: {
    getNavigationItems(params) {
      return axios({
        method: 'get',
        url: _apiUrl + '/dashboard/navigation',
        params: params
      });
    },
    getDefectItems(params) {
      return axios({
        method: 'get',
        url: _apiUrl + '/dashboard/defects',
        headers: {
          Authorization: authHeader()
        },
        params: params
      });
    }
  }
};
